<template>
  <div v-if="this.$user && this.$user.is_test" class="w-full fixed top-0 left-0 bg-red p-2 font-bold text-white z-[999999] text-center">
    Mode test de la plateforme FID
  </div>
  <header-block v-if="$route.name != 'incoming' && $route.name != 'unsub' && $route.name != 'tracking-optout' && $route.name != 'preview'" @openModal="openModal" />
  <Transition>
    <Notification
      v-if="isNotification"
      :message="message"
      :isError="isError"
      @closeNotification="closeNotification"
    />
  </Transition>

  <Transition>
    <Modal
      v-if="isModal"
      :message="messageModal"
      :title="titleModal"
      :img="imgModal"
      @closeModal="closeModal"
    />
  </Transition>

  <Transition>
    <ModalWinner
      v-if="isWinnersModal"
      :title="'Gagnants'"
      :img="$template.winners_image"
      @closeModal="closeWinnersModal"
    />
  </Transition>

  <Transition>
    <Modal
      v-if="isReglementModal"
      :message="reglementModalMessage"
      :title="reglementModalTitle"
      :img="reglementModalImg"
      @closeModal="closeReglementModal"
    />
  </Transition>

  <router-view
    @openNotification="openNotification"
    @openModal="openModal"
  ></router-view>
</template>

<script>
import Notification from './common/components/Notification.vue'
import Modal from './common/components/Modal.vue'
import HeaderBlock from './common/components/HeaderBlock.vue'
import ModalWinner from './common/components/ModalWinner.vue';

export default {
  name: 'AppComponent',
  components: {
    HeaderBlock,
    Notification,
    Modal,
    ModalWinner
  },
  data: () => ({
    isNotification: false,
    isModal: false,

    message: '',
    isError: false,
    messageModal: '',
    titleModal: '',
    imgModal: ''
  }),
  computed:{
    currentRouteName() {
      return this.$route.name;
    },
    isWinnersModal() {
      return this.$store.isWinnersModal
    },
    isReglementModal() {
      return this.$store.isReglementModal
    },
    reglementModalTitle() {
      return this.$store.reglementModalTitle
    },
    reglementModalMessage() {
      return this.$store.reglementModalMessage
    },
    reglementModalImg() {
      return this.$store.reglementModalImg
    },
  },
  watch: {
    $template: {
      handler() {
        if (this.$template) {
          document.body.style.backgroundColor =
            this.$template.page_background_color
          document.body.style.color = this.$template.page_text_color
          document.title = this.$template.title_page
        }
      },
      immediate: true
    },
    $currentRouteName: {
      handler() {
        window.scrollTo(0,0);
      },
      immediate: true
    }
  },
  methods: {
    openNotification(message, isError) {
      this.isNotification = true
      this.message = message
      this.isError = isError
      setTimeout(() => {
        this.isNotification = false
        this.message = ''
        this.isError = false
      }, '3000')
    },
    closeNotification() {
      this.isNotification = false
      this.message = ''
    },
    openModal(title, message, img) {
      // document.body.style.overflow = 'hidden'
      this.isModal = true
      this.messageModal = message
      this.titleModal = title
      this.imgModal = img
    },
    closeModal() {
      // document.body.style.overflow = 'auto'
      this.isModal = false
      this.messageModal = ''
      this.titleModal = ''
      this.imgModal = ''
    },
    closeWinnersModal() {
      this.$store.setWinnersModal(false)
    },
    closeReglementModal() {
      this.$store.closeReglementModal()
    }
  },
  created() {
    window.scrollTo(0,0);
  },
}
</script>
